import { api } from "./configs/axiosConfigs";
import { defineCancelApiObject } from "./configs/axiosUtils";
import { store } from "../redux/store";

export const EspelhoAPI = {
    setEspelhoLabel: async function (id, data, cancel = false) {
        const token = store.getState().user.token;

        const response = await api.request({
            url: `Espelho/Label/${id}`,
            method: "PUT",
            headers: { Authorization: "bearer " + token },
            data: data,
            // retrieving the signal value by using the property name
            signal: cancel
                ? cancelApiObject[this.get.name].handleRequestCancellation().signal
                : undefined,
        });

        // returning the user returned by the API
        return response.data;
    },

    createTerminal: async function (data, cancel = false) {
        const token = store.getState().user.token;

        const response = await api.request({
            url: `Espelho/Terminal`,
            method: "POST",
            headers: { Authorization: "bearer " + token },
            data: data,
            // retrieving the signal value by using the property name
            signal: cancel
                ? cancelApiObject[this.get.name].handleRequestCancellation().signal
                : undefined,
        });

        // returning the user returned by the API
        return response.data;
    },

};

// defining the cancel API object for UserAPI
const cancelApiObject = defineCancelApiObject(EspelhoAPI);
